var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoga(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "y70u8f7gqa",
    d: "M0.255 0.538L16.845 0.538 16.845 9.334 0.255 9.334z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M20.7 19.381c0 2.916-4.634 5.28-10.35 5.28-5.716 0-10.35-2.364-10.35-5.28 0-2.916 4.634-5.28 10.35-5.28 5.716 0 10.35 2.364 10.35 5.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003DB3",
    d: "M19.896 12.491c0 2.796-4.274 5.062-9.546 5.062-5.272 0-9.546-2.266-9.546-5.062 0-2.795 4.274-5.061 9.546-5.061 5.272 0 9.546 2.266 9.546 5.061"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.8 .362)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "62vdbr2vdb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y70u8f7gqa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B0F0FF",
    d: "M16.845 4.936c0 2.43-3.713 4.398-8.295 4.398-4.581 0-8.295-1.969-8.295-4.398C.255 2.507 3.97.538 8.55.538c4.582 0 8.295 1.969 8.295 4.398",
    mask: "url(#62vdbr2vdb)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoga);
export default __webpack_public_path__ + "static/media/yoga.9ea751ea1fdb7c974a2b3f760e32c70a.svg";
export { ForwardRef as ReactComponent };